'use strict';

module.exports = link;

var all = require('../all');

function link(h, node) {
  var props = {
    url: node.properties.href || '',
    title: node.properties.title || null
  };

  return h(node, 'link', props, all(h, node));
}



//////////////////
// WEBPACK FOOTER
// ../node_modules/hast-util-to-mdast/handlers/link.js
// module id = 1034
// module chunks = 0